import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

import {
  CSRF_TOKEN,
  requestCallback
} from '../lib/helpers';

import {
  useModal,
} from '../hooks';

import Modal from './Modal';

const ClearBanHistoryModal = ({
  klassName = 'Badge Badge--gray Badge--icon-unlock',
  banType = 'user',
  id,
}) => {
  const [
    modal,
    modalSet,
    $submitButton,
  ] = useModal({
    keyboardBindings: true,
  })

  function handleRequest() {
    requestCallback(axios.put(`/${gon.currentProvider}/api/users/${id}/clear_penalty_history`, {
      authenticity_token: CSRF_TOKEN
    }))
  }

  function toggleModal() {
    modalSet(!modal)
  }

  return (
    <React.Fragment>
      <a
        className={klassName}
        onClick={toggleModal}
      >
        Clear History
      </a>

      <Modal
        isActive={modal}
        onToggleModal={toggleModal}
      >
        <h3 className='Modal__h3'>Clear penalty history of {id}</h3>

        <div className='Modal__p__wrapper'>
          <p className='Modal__p'>Are you sure you want to clear penalty history of this user?</p>
        </div>

        <div className='Modal__footer Modal__footer--without-border'>
          <a
            className='Button Button--gray-light'
            onClick={toggleModal}
          >
            Cancel
          </a>

          <button
            className='Button Button--blue'
            onClick={handleRequest}
            ref={$submitButton}
          >
            Submit
          </button>
        </div>
      </Modal>
    </React.Fragment>
  );
}

ClearBanHistoryModal.propTypes = {
  banType: PropTypes.oneOf(['user', 'permanent', 'ip_address', 'uuid', 'word', 'url']),
};

export default ClearBanHistoryModal
